module.exports = __webpack_public_path__ + "img/card.542c1bbc.png";